import React, { forwardRef } from "react";
import Box from "@mui/material/Box";

const DSBox = forwardRef<HTMLDivElement, React.ComponentProps<typeof Box>>(
  (props, ref) => <Box ref={ref} {...props} />,
);

export default DSBox;
